<div class="lib-widget-add-wrapper">
    <p>{{ 'OICL_OPENBRIDGE.INSTRUMENT_FIELD.WIDGET.ADD.DESCRIPTION' | translate }}</p>
</div>
